import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import { mapGetters } from 'vuex'
Vue.use(Vuex);
const headers = {
    "Content-Type": "application/json",
};
 const baseUrl = 'https://ant.aliceblueonline.com/rest/AliceBlueAPIService/';
//const baseUrl = 'https://antaws.aliceblueonline.com/rest/AliceBlueAPIService/';
const commonUrl = 'https://ant.aliceblueonline.com/';

export default {
    data: () => ({
        //
    }),
    computed: {
        ...mapGetters({
            userId:'getUserId',
            sessionId:'getSessionId',
        }),
    },
    authHeaders() {
        let userId = localStorage.getItem("clientId");
        let sessionId = localStorage.getItem("sessionId");
        let headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userId + " " + sessionId,
        };
        return headers;
    },
    commonUrlHeaders() {
       // let userId = localStorage.getItem("clientId");
        let sessionId = localStorage.getItem("sessionId");
        let headers = {
            
            Authorization: "Bearer" +  " " + sessionId,
        };
        return headers;
    },
    async ssoLogin (payload) {
        return await axios.post(`${baseUrl}sso/getUserDetailsByAuth`, payload)
    },
    async getVendorDetails (payload) {
        return await axios.post(`${baseUrl}vendorApp/getAppDetails`, payload, {
            headers: this.authHeaders()
        })
    },
    async createVendor (payload) {
        return await axios.post(`${baseUrl}vendorApp/createNewVendorApp`, payload, {
            headers: this.authHeaders()
        })
    },
    async updateVendor (payload) {
        return await axios.post(`${baseUrl}vendorApp/updateVendorApp`, payload, {
            headers: this.authHeaders()
        })
    },
    async deleteVendor (payload) {
        return await axios.post(`${baseUrl}vendorApp/deleteVendorApp`, payload, {
            headers: this.authHeaders()
        })
    },
    async reGenerateSecretKey (payload) {
        return await axios.post(`${baseUrl}vendorApp/regenerateApiSecret`, payload, {
            headers: this.authHeaders()
        })
    },
    async getApiKey(){
        return await axios.get(`${commonUrl}omk/sso-auth/api/key`, {
            headers: this.commonUrlHeaders()
        })
    },
    async generateApiKey(payload){
        return await axios.post(`${commonUrl}omk/sso-auth/api/key/generate`, payload, {
            headers: this.commonUrlHeaders()
        })
    },
    async reGenerateApiKey(payload){
        return await axios.post(`${commonUrl}omk/sso-auth/api/key/regenerate`, payload, {
            headers: this.commonUrlHeaders()
        })
    },
    async logout (jsonObj) {
        return await axios.post(`https://ant.aliceblueonline.com/rest/AliceBlueAPIService/customer/logout`, jsonObj, {
          headers: this.authHeaders(),
        });
    },
}
